/* Gift Box Builder v2 – American Socks
   State lives in memory; grid HTML comes from sections/gift-box-grid.liquid
   (Section Rendering API), so Shopify does filtering/sorting server-side. */
(function () {
  'use strict';

  function GiftBoxBuilder(root) {
    this.root = root;
    this.$ = function (s) { return root.querySelector(s); };
    this.$$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    this.socksPerBox = parseInt(root.dataset.socks, 10) || 3;
    this.discount = parseInt(root.dataset.discount, 10) || 0;
    this.rootUrl = (root.dataset.root || '/').replace(/\/?$/, '/');
    this.moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    try { this.t = JSON.parse(this.$('[data-gbb-strings]').textContent); } catch (e) { this.t = {}; }

    this.state = { box: null, line: null, collection: null, socks: [], accessory: null };
    this.filters = {};          // param -> [values]
    this.cache = {};            // url -> html
    this.reqId = 0;
    this.mode = 'socks';
    this.step = 1;

    this.grid = this.$('[data-gbb-grid]');
    this.filtersEl = this.$('[data-gbb-filters]');
    this.openDd = null;
    // filters live inline in the toolbar (after search) as dropdowns
    var search = this.$('.gbb__search');
    if (search) search.parentNode.insertBefore(this.filtersEl, search.nextSibling);
    this.activeEl = document.createElement('div');
    this.activeEl.className = 'gbb__active';
    this.$('.gbb__toolbar').insertAdjacentElement('afterend', this.activeEl);
    // deal bar (explains box + N socks = discount, with live progress)
    var dealEl = this.$('.gbb__deal');
    this.dealBar = document.createElement('div');
    this.dealBar.className = 'gbb__dealbar';
    this.dealBar.innerHTML = '<div class="gbb__dealbar-txt"><b>' + escapeHtml(dealEl ? dealEl.textContent.trim() : '') + '</b><span data-deal-msg></span></div><div class="gbb-mini" data-deal-steps></div>';
    var tabs = this.$('.gbb__tabs');
    tabs.parentNode.insertBefore(this.dealBar, tabs);
    // mini progress in the mobile bottom bar
    var tg = this.$('[data-gbb-summary-toggle]');
    this.miniEl = document.createElement('span');
    this.miniEl.className = 'gbb-mini';
    tg.insertBefore(this.miniEl, tg.firstChild); var me = this; this.barAtc = document.createElement('button'); this.barAtc.type = 'button'; this.barAtc.className = 'gbb__bar-atc'; this.barAtc.textContent = this.str('add_to_cart'); tg.parentNode.insertBefore(this.barAtc, tg.nextSibling); this.barAtc.addEventListener('click', function () { me.addToCart(); });
    // toast
    this.toast = document.createElement('div');
    this.toast.className = 'gbb-toast';
    document.body.appendChild(this.toast);
    this.bind();
    this.render();
    var firstTab = this.$('.gbb__tab:not([data-accessory])');
    if (firstTab) this.selectTab(firstTab, true); // preload socks while the customer picks a box
  }

  GiftBoxBuilder.prototype.money = function (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    var v = (cents / 100);
    var fmt = this.moneyFormat;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var out;
    if (key === 'amount_no_decimals') out = Math.round(v).toLocaleString('en-US');
    else if (key === 'amount_with_comma_separator') out = v.toFixed(2).replace('.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') out = Math.round(v).toLocaleString('de-DE');
    else out = v.toFixed(2);
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  GiftBoxBuilder.prototype.str = function (k, n) {
    var s = this.t[k] || '';
    return n == null ? s : s.replace('[n]', n);
  };

  /* ---------- events ---------- */
  GiftBoxBuilder.prototype.bind = function () {
    var self = this;

    this.$$('.gbb-box').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.state.box = {
          variantId: btn.dataset.variantId,
          price: parseInt(btn.dataset.price, 10) || 0,
          title: btn.dataset.title,
          image: btn.dataset.image
        };
        self.$$('.gbb-box').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
        self.goto(2);
      });
    });

    this.$$('[data-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.goto(parseInt(btn.dataset.goto, 10)); });
    });

    this.$$('.gbb__tab').forEach(function (tab) {
      tab.addEventListener('click', function () { self.selectTab(tab); });
    });

    this.$('[data-gbb-search]').addEventListener('input', function () { self.applySearch(); });
    this.$('[data-gbb-instock]').addEventListener('change', function () { self.load(); });
    this.$('[data-gbb-sort]').addEventListener('change', function () { self.load(); });
    this.$('[data-gbb-filter-toggle]').addEventListener('click', function () {
      self.root.classList.toggle('gbb--filters-open');
    });
    this.$('[data-gbb-summary-toggle]').addEventListener('click', function () {
      self.root.classList.toggle('gbb--summary-open');
    });

    this.filtersEl.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.name) return;
      var list = self.filters[input.name] || [];
      if (input.checked) { if (list.indexOf(input.value) === -1) list.push(input.value); }
      else list = list.filter(function (v) { return v !== input.value; });
      self.filters[input.name] = list;
      self.load();
    });

    this.activeEl.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-clear')) self.filters = {};
      else self.filters[b.dataset.param] = (self.filters[b.dataset.param] || []).filter(function (v) { return v !== b.dataset.value; });
      self.load();
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.gbb-dd')) return;
      self.$$('.gbb-dd[open]').forEach(function (d) { d.open = false; });
      self.openDd = null;
    });

    this.grid.addEventListener('click', function (e) {
      var size = e.target.closest('.gbb-size');
      if (!size || size.disabled) return;
      var card = size.closest('.gbb-card');
      self.addItem(card, size);
    });

    this.$('[data-gbb-slots]').addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (!rm) return;
      self.state.socks.splice(parseInt(rm.dataset.remove, 10), 1);
      self.render();
    });
    this.$('[data-gbb-acc-slot]').addEventListener('click', function (e) {
      if (e.target.closest('[data-remove-acc]')) { self.state.accessory = null; self.render(); }
    });

    this.$('[data-gbb-atc]').addEventListener('click', function () { self.addToCart(); });
  };

  /* ---------- navigation ---------- */
  GiftBoxBuilder.prototype.goto = function (step) {
    if (step >= 2 && !this.state.box) step = 1;
    this.$('[data-panel="1"]').hidden = step !== 1;
    this.$('[data-panel="2"]').hidden = step === 1;
    if (step >= 2 && !this.state.collection) {
      var first = this.$('.gbb__tab:not([data-accessory])');
      if (first) this.selectTab(first, true);
    }
    if (step === 3) { this.openUpsell(); return; }
    this.step = step;
    this.render();
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 80;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  };

  GiftBoxBuilder.prototype.selectTab = function (tab, silent) {
    var isAcc = tab.hasAttribute('data-accessory');
    var handle = tab.dataset.collection;
    if (!isAcc && this.state.line && this.state.line !== tab.dataset.line && this.state.socks.length) {
      if (!window.confirm(this.str('switch_line'))) return;
      this.state.socks = [];
    }
    if (!isAcc) this.state.line = tab.dataset.line;
    this.$$('.gbb__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    if (this.state.collection !== handle) {
      this.state.collection = handle;
      this.filters = {};
      this.$('[data-gbb-search]').value = '';
      this.load();
    }
    this.mode = isAcc ? 'accessory' : 'socks';
    if (!silent) this.render();
    else this.renderSteps();
  };

  /* ---------- grid loading ---------- */
  GiftBoxBuilder.prototype.buildUrl = function () {
    var p = new URLSearchParams();
    p.set('section_id', 'gift-box-grid');
    if (this.$('[data-gbb-instock]').checked) p.set('filter.v.availability', '1');
    var sort = this.$('[data-gbb-sort]').value;
    if (sort && sort !== 'manual') p.set('sort_by', sort);
    var f = this.filters;
    Object.keys(f).forEach(function (k) { f[k].forEach(function (v) { p.append(k, v); }); });
    return this.rootUrl + 'collections/' + this.state.collection + '?' + p.toString();
  };

  GiftBoxBuilder.prototype.load = function () {
    var self = this;
    if (!this.state.collection) return;
    var url = this.buildUrl();
    var id = ++this.reqId;
    this.grid.classList.add('is-loading');
    var done = function (html) {
      if (id !== self.reqId) return;
      self.cache[url] = html;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var facets = doc.querySelector('.gbb-facets');
      var cards = doc.querySelector('.gbb-cards');
      self.filtersEl.innerHTML = facets ? facets.innerHTML : '';
      self.grid.innerHTML = cards ? cards.innerHTML : '';
      self.grid.classList.remove('is-loading');
      self.$$('.gbb-card').forEach(function (c, i) { var md = c.querySelector('.gbb-card__media'), sz = c.querySelector('.gbb-card__sizes'); if (md && sz) md.appendChild(sz); if (i < 12) Array.prototype.forEach.call(c.querySelectorAll('img'), function (im) { im.loading = 'eager'; }); });
      self.$$('[data-gbb-t]').forEach(function (el) { el.textContent = self.str(el.dataset.gbbT); });
      self.buildDropdowns();
      self.renderActive();
      self.applySearch();
      self.markCards();
    };
    if (this.cache[url]) return done(this.cache[url]);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(done)
      .catch(function () { self.grid.classList.remove('is-loading'); });
  };

  GiftBoxBuilder.prototype.buildDropdowns = function () {
    var self = this;
    this.$$('.gbb-facet').forEach(function (f) {
      var param = f.dataset.param;
      if (param === 'filter.v.availability') { f.remove(); return; }
      var labelEl = f.querySelector('.gbb-facet__label');
      var label = labelEl ? labelEl.textContent.trim() : param;
      var n = f.querySelectorAll('input:checked').length;
      var d = document.createElement('details');
      d.className = 'gbb-dd' + (n ? ' has-value' : '');
      d.dataset.param = param;
      d.innerHTML = '<summary>' + escapeHtml(label) + (n ? ' <b>' + n + '</b>' : '') + '</summary>';
      var panel = f.querySelector('.gbb-facet__values');
      if (panel) { panel.className = 'gbb-dd__panel'; d.appendChild(panel); }
      if (self.openDd === param) d.open = true;
      d.addEventListener('toggle', function () {
        if (d.open) {
          self.openDd = param;
          self.$$('.gbb-dd').forEach(function (o) { if (o !== d) o.open = false; });
        } else if (self.openDd === param) { self.openDd = null; }
      });
      f.parentNode.replaceChild(d, f);
    });
  };

  GiftBoxBuilder.prototype.renderActive = function () {
    var self = this, html = '', any = false;
    Object.keys(this.filters).forEach(function (k) {
      self.filters[k].forEach(function (v) {
        any = true;
        html += '<button type="button" data-param="' + escapeHtml(k) + '" data-value="' + escapeHtml(v) + '">' + escapeHtml(v) + ' ×</button>';
      });
    });
    if (any) html += '<button type="button" class="gbb__clear" data-clear>' + escapeHtml(this.str('clear') || 'Clear all') + '</button>';
    this.activeEl.innerHTML = html;
  };

  GiftBoxBuilder.prototype.applySearch = function () {
    var q = (this.$('[data-gbb-search]').value || '').trim().toLowerCase();
    var visible = 0;
    this.$$('.gbb-card').forEach(function (c) {
      var show = !q || (c.dataset.search || '').indexOf(q) !== -1;
      c.hidden = !show; if (show) visible++;
    });
    var empty = this.grid.querySelector('.gbb-empty--search');
    if (!visible && q) {
      if (!empty) { empty = document.createElement('p'); empty.className = 'gbb-empty gbb-empty--search'; this.grid.appendChild(empty); }
      empty.textContent = this.str('empty');
    } else if (empty) empty.remove();
  };

  /* ---------- box contents ---------- */
  GiftBoxBuilder.prototype.addItem = function (card, size) {
    var item = {
      variantId: size.dataset.variantId,
      productId: card.dataset.productId,
      title: card.dataset.title,
      size: size.dataset.size,
      price: parseInt(size.dataset.price, 10) || 0,
      image: size.dataset.image
    };
    if (this.mode === 'accessory') {
      this.state.accessory = item;
    } else {
      if (this.state.socks.length >= this.socksPerBox) { this.flash(this.str('full')); return; }
      this.state.socks.push(item);
      // mobile: keep the bottom bar compact (no auto-open)
    }
    card.classList.add('just-added');
    setTimeout(function () { card.classList.remove('just-added'); }, 600);
    this.render();
    if (this.mode !== 'accessory') this.showToast('✓ ' + item.title.split(' - ')[0] + '  ·  ' + this.state.socks.length + '/' + this.socksPerBox + '  ·  ' + this.$('[data-gbb-hint]').textContent);
  };

  GiftBoxBuilder.prototype.showToast = function (msg) {
    var t = this.toast;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(this._toastT);
    this._toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  };

  GiftBoxBuilder.prototype.flash = function (msg) {
    var hint = this.$('[data-gbb-hint]');
    hint.textContent = msg;
    hint.classList.add('is-alert');
    this.root.classList.add('gbb--summary-open');
    var s = this.$('[data-gbb-summary]');
    s.classList.remove('shake'); void s.offsetWidth; s.classList.add('shake');
    var self = this;
    clearTimeout(this._flashT);
    this._flashT = setTimeout(function () { hint.classList.remove('is-alert'); self.renderSummary(); }, 2500);
  };

  GiftBoxBuilder.prototype.markCards = function () {
    var counts = {};
    this.state.socks.forEach(function (s) { counts[s.productId] = (counts[s.productId] || 0) + 1; });
    if (this.state.accessory) counts[this.state.accessory.productId] = (counts[this.state.accessory.productId] || 0) + 1;
    var self = this;
    this.$$('.gbb-card').forEach(function (c) {
      var n = counts[c.dataset.productId] || 0;
      c.classList.toggle('is-in-box', n > 0);
      var badge = c.querySelector('.gbb-card__badge');
      if (badge) { badge.hidden = !n; badge.textContent = '✓ ' + self.str('in_box') + (n > 1 ? ' ×' + n : ''); }
    });
  };

  /* ---------- rendering ---------- */
  GiftBoxBuilder.prototype.renderSteps = function () {
    var s = this.state, full = s.socks.length >= this.socksPerBox;
    var step = this.step || 1;
    var activeStep = step === 1 ? 1 : (this.mode === 'accessory' ? 3 : 2);
    this.$$('.gbb__step').forEach(function (b) {
      var n = parseInt(b.dataset.goto, 10);
      b.classList.toggle('is-active', n === activeStep);
      b.classList.toggle('is-done', (n === 1 && !!s.box) || (n === 2 && full));
      b.disabled = (n === 2 && !s.box) || (n === 3 && !full);
    });
    var name = this.$('[data-gbb-box-name]');
    if (name) name.textContent = s.box ? '· ' + s.box.title : '';
  };

  GiftBoxBuilder.prototype.renderSummary = function () {
    var s = this.state, self = this, n = this.socksPerBox;
    if (s.box) {
      this.$('[data-gbb-box-img]').src = s.box.image || '';
      this.$('[data-gbb-box-title]').textContent = s.box.title;
    }
    var slots = '';
    for (var i = 0; i < n; i++) {
      var it = s.socks[i];
      slots += it
        ? '<li class="gbb-slot is-filled" title="' + escapeHtml(it.title.split(' - ')[0]) + '"><img src="' + it.image + '" alt="' + escapeHtml(it.title) + '">' + (it.size && it.size !== 'Default Title' && it.size !== 'One Size' ? '<span class="gbb-slot__size">' + escapeHtml(it.size) + '</span>' : '') + '<button type="button" data-remove="' + i + '" aria-label="Remove">×</button></li>'
        : '<li class="gbb-slot"><span class="gbb-slot__n">' + (i + 1) + '</span></li>';
    }
    this.$('[data-gbb-slots]').innerHTML = slots;

    var accSlot = this.$('[data-gbb-acc-slot]');
    var accTab = this.$('.gbb__tab[data-accessory]');
    if (accTab) {
      accSlot.innerHTML = s.accessory
        ? '<div class="gbb-slot is-filled"><img src="' + s.accessory.image + '" alt=""><span><b>' + escapeHtml(s.accessory.title) + '</b></span><button type="button" data-remove-acc aria-label="Remove">×</button></div>'
        : '<button type="button" class="gbb-slot gbb-slot--acc" data-goto-acc' + (s.socks.length < n ? ' disabled' : '') + '>+ ' + escapeHtml(accTab.textContent.trim()) + '</button>';
      var go = accSlot.querySelector('[data-goto-acc]');
      if (go) go.addEventListener('click', function () { self.goto(3); });
    }

    var socksTotal = s.socks.reduce(function (a, b) { return a + b.price; }, 0);
    var subtotal = (s.box ? s.box.price : 0) + socksTotal + (s.accessory ? s.accessory.price : 0);
    var full = s.socks.length >= n;
    var saving = full ? Math.round(socksTotal * this.discount / 100) : 0;
    this.$('[data-gbb-subtotal]').textContent = this.money(subtotal);
    this.$('[data-gbb-save-row]').hidden = !saving;
    this.$('[data-gbb-save]').textContent = '−' + this.money(saving);
    this.$('[data-gbb-total]').textContent = this.money(subtotal - saving);
    this.$('[data-gbb-total-mini]').textContent = this.money(subtotal - saving);
    this.$('[data-gbb-progress-bar]').style.width = Math.min(100, s.socks.length / n * 100) + '%';
    this.$('[data-gbb-progress-text]').textContent = this.$('.gbb__summary-title').textContent.trim() + ' · ' + s.socks.length + '/' + n;

    var missing = n - s.socks.length;
    var hint = this.$('[data-gbb-hint]');
    if (!hint.classList.contains('is-alert')) {
      hint.textContent = missing <= 0 ? this.str('ready') : (missing === 1 ? this.str('missing_one') : this.str('missing_many', missing));
    }
    hint.classList.toggle('is-ready', missing <= 0);
    var dots = s.box ? '<span class="gbb-dot gbb-dot--box is-on"><img src="' + s.box.image + '" alt=""></span><i class="gbb-plus">+</i>' : '';
    for (var j = 0; j < n; j++) {
      var d = s.socks[j];
      dots += '<span class="gbb-dot' + (d ? ' is-on' : '') + '">' + (d ? '<img src="' + d.image + '" alt="">' : (j + 1)) + '</span>';
    }
    dots += '<span class="gbb-dot gbb-dot--prize' + (missing <= 0 ? ' is-on' : '') + '">−' + this.discount + '%</span>';
    this.miniEl.innerHTML = dots;
    this.$('[data-deal-steps]').innerHTML = dots;
    var msg = missing <= 0 ? this.str('ready') : (missing === 1 ? this.str('missing_one') : this.str('missing_many', missing));
    this.$('[data-deal-msg]').textContent = msg;
    this.$('[data-gbb-progress-text]').innerHTML = '<b>' + escapeHtml(s.box ? s.box.title : '') + '</b><small>' + s.socks.length + '/' + n + (missing <= 0 ? ' ✓ ' : ' · ') + '−' + this.discount + '%</small>';
    this.dealBar.classList.toggle('is-ready', missing <= 0);
    this.$('[data-gbb-atc]').disabled = !(s.box && full); if (this.barAtc) { this.barAtc.disabled = !(s.box && full); this.barAtc.classList.toggle('is-ready', !!(s.box && full)); }
    this.root.classList.toggle('gbb--full', full);
  };

  GiftBoxBuilder.prototype.render = function () {
    this.renderSteps();
    this.renderSummary();
    this.markCards();
  };

  /* ---------- extras (stickers) shown after "Add box to cart" ---------- */
  GiftBoxBuilder.prototype.openUpsell = function () {
    var self = this, s = this.state;
    var accTab = this.$('.gbb__tab[data-accessory]');
    if (!s.box || s.socks.length < this.socksPerBox) return;
    if (!accTab) { this.doAddToCart(); return; }
    s.extras = s.extras || [];
    if (!this.upsell) {
      var m = document.createElement('div');
      m.className = 'gbb gbb-up';
      m.setAttribute('data-gbb-ready', '');
      m.innerHTML =
        '<div class="gbb-up__backdrop" data-up-close></div>' +
        '<div class="gbb-up__dialog" role="dialog" aria-modal="true">' +
          '<button type="button" class="gbb-up__x" data-up-close aria-label="Close">×</button>' +
          '<div class="gbb-up__head">' +
            '<span class="gbb-up__ok" data-up-ok></span>' +
            '<h3 class="gbb-up__title">' + escapeHtml(this.str('upsell_title') || 'Finish it with stickers?') + '</h3>' +
            '<p class="gbb-up__sub">' + escapeHtml(this.str('upsell_sub') || 'Optional – add one or more sticker packs to your box.') + '</p>' +
          '</div>' +
          '<div class="gbb-up__grid" data-up-grid><p class="gbb-empty">' + escapeHtml(this.str('loading') || '…') + '</p></div>' +
          '<div class="gbb-up__foot">' +
            '<button type="button" class="gbb-up__skip" data-up-skip></button>' +
            '<button type="button" class="btn gbb-up__go" data-up-go></button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(m);
      this.upsell = m;
      m.addEventListener('click', function (e) {
        if (e.target.closest('[data-up-close]')) { self.closeUpsell(); return; }
        if (e.target.closest('[data-up-skip]')) { s.extras = []; self.closeUpsell(); self.doAddToCart(); return; }
        if (e.target.closest('[data-up-go]')) { self.closeUpsell(); self.doAddToCart(); return; }
        var b = e.target.closest('.gbb-size');
        if (!b || b.disabled) return;
        var card = b.closest('.gbb-card'), id = b.dataset.variantId, idx = -1;
        s.extras.forEach(function (x, i) { if (x.variantId === id) idx = i; });
        if (idx > -1) s.extras.splice(idx, 1);
        else s.extras.push({ variantId: id, productId: card.dataset.productId, title: card.dataset.title, price: parseInt(b.dataset.price, 10) || 0, image: b.dataset.image });
        self.renderUpsell();
      });
      var url = this.rootUrl + 'collections/' + accTab.dataset.collection + '?section_id=gift-box-grid&filter.v.availability=1';
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelector('.gbb-cards');
        m.querySelector('[data-up-grid]').innerHTML = cards ? cards.innerHTML : '';
        Array.prototype.forEach.call(m.querySelectorAll('[data-gbb-t]'), function (el) { el.textContent = self.str(el.dataset.gbbT); });
        self.renderUpsell();
      });
    }
    this.upsell.classList.add('is-open');
    document.documentElement.classList.add('gbb-lock');
    this.mode = 'accessory'; this.step = 3; this.renderSteps();
    this.renderUpsell();
  };

  GiftBoxBuilder.prototype.closeUpsell = function () {
    if (this.upsell) this.upsell.classList.remove('is-open');
    document.documentElement.classList.remove('gbb-lock');
    this.mode = 'socks'; this.step = 2; this.renderSteps();
  };

  GiftBoxBuilder.prototype.renderUpsell = function () {
    if (!this.upsell) return;
    var s = this.state, self = this, ids = {};
    (s.extras || []).forEach(function (x) { ids[x.variantId] = true; });
    Array.prototype.forEach.call(this.upsell.querySelectorAll('.gbb-card'), function (c) {
      var on = false;
      Array.prototype.forEach.call(c.querySelectorAll('.gbb-size'), function (b) {
        var sel = !!ids[b.dataset.variantId];
        b.classList.toggle('is-selected', sel);
        if (sel) on = true;
      });
      c.classList.toggle('is-in-box', on);
      var badge = c.querySelector('.gbb-card__badge');
      if (badge) { badge.hidden = !on; badge.textContent = '✓ ' + self.str('in_box'); }
    });
    var socksTotal = s.socks.reduce(function (a, b) { return a + b.price; }, 0);
    var extrasTotal = (s.extras || []).reduce(function (a, b) { return a + b.price; }, 0);
    var total = (s.box ? s.box.price : 0) + socksTotal - Math.round(socksTotal * this.discount / 100) + extrasTotal;
    var n = (s.extras || []).length;
    var go = this.upsell.querySelector('[data-up-go]'), skip = this.upsell.querySelector('[data-up-skip]');
    go.textContent = (this.str('add_to_cart') || 'Add to cart') + (n ? ' (+' + n + ')' : '') + ' · ' + this.money(total);
    go.disabled = !n;
    skip.textContent = this.str('no_thanks') || 'No thanks, just the box';
    this.upsell.classList.toggle('has-extras', !!n);
    this.upsell.querySelector('[data-up-ok]').textContent = '✓ ' + (s.box ? s.box.title : '') + ' · ' + s.socks.length + '/' + this.socksPerBox;
  };

  /* ---------- cart ---------- */
  GiftBoxBuilder.prototype.addToCart = function () { this.openUpsell(); };

  GiftBoxBuilder.prototype.doAddToCart = function () {
    var s = this.state, self = this;
    if (!s.box || s.socks.length < this.socksPerBox) return;
    var btn = this.$('[data-gbb-atc]');
    btn.disabled = true; btn.textContent = this.str('adding');
    var bundleId = 'GB-' + Date.now().toString(36).toUpperCase();
    var props = { _bundle_id: bundleId, _bundle_box: s.box.title, _bundle_line: s.line || '' };
    var items = [{ id: +s.box.variantId, quantity: 1, properties: props }];
    s.socks.forEach(function (it) { items.push({ id: +it.variantId, quantity: 1, properties: props }); });
    (s.extras || []).forEach(function (it) { items.push({ id: +it.variantId, quantity: 1, properties: props }); });

    fetch(this.rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        self.state.socks = []; self.state.accessory = null; self.state.extras = [];
        btn.textContent = self.str('add_to_cart');
        self.render();
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = self.str('add_to_cart');
        self.flash(self.str('error'));
      });
  };

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    document.querySelectorAll('.gbb:not([data-gbb-ready])').forEach(function (el) {
      el.setAttribute('data-gbb-ready', '');
      el.__gbb = new GiftBoxBuilder(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ===== v3.2: animated box (fly-in + black stars) + gift note ===== */
(function () {
  'use strict';
  var root = document.querySelector('.gbb[data-gbb-ready]');
  var inst = root && root.__gbb;
  if (!inst) return;
  var P = Object.getPrototypeOf(inst);
  if (P.__v3) return;
  P.__v3 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function isMobile() { return window.matchMedia('(max-width: 989px)').matches; }
  function txt(k, d) { return (inst.t && inst.t[k]) || d; }

  P.flyTo = function (img, target, done) {
    if (!img || !target || reduce || !img.animate) { if (done) done(); return; }
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) { if (done) done(); return; }
    var c = document.createElement('img');
    c.src = img.currentSrc || img.src;
    c.className = 'gbb-fly';
    c.style.left = a.left + 'px'; c.style.top = a.top + 'px';
    c.style.width = a.width + 'px'; c.style.height = a.height + 'px';
    document.body.appendChild(c);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var s = Math.max(0.12, b.width / a.width);
    var an = c.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 90) + 'px) scale(' + (1 + s) / 2 + ') rotate(-10deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ') rotate(0deg)', opacity: 0.7 }
    ], { duration: 650, easing: 'cubic-bezier(.5,0,.3,1)' });
    an.onfinish = function () {
      c.remove();
      target.classList.remove('gbb-pop'); void target.offsetWidth; target.classList.add('gbb-pop');
      if (done) done();
    };
  };

  var STAR = '<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M12 1.5l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.6l-6.4 3.5L7 14 1.7 9l7.2-.9z" fill="#141414"/></svg>';
  P.confetti = function (target) {
    if (reduce || !document.body.animate) return;
    var r = target ? target.getBoundingClientRect() : { left: window.innerWidth / 2, top: window.innerHeight / 2, width: 0, height: 0 };
    var x = r.left + r.width / 2, y = r.top + r.height / 2;
    for (var i = 0; i < 28; i++) {
      var d = document.createElement('i');
      var size = 10 + Math.round(Math.random() * 16);
      d.className = 'gbb-confetti';
      d.innerHTML = STAR;
      d.style.left = x + 'px'; d.style.top = y + 'px';
      d.style.width = size + 'px'; d.style.height = size + 'px';
      d.style.margin = (-size / 2) + 'px 0 0 ' + (-size / 2) + 'px';
      d.style.background = 'none'; d.style.borderRadius = '0';
      document.body.appendChild(d);
      var ang = Math.random() * Math.PI * 2, dist = 70 + Math.random() * 150, rot = (Math.random() - 0.5) * 540;
      var an = d.animate([
        { transform: 'translate(0,0) scale(.3) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist - 70) + 'px) scale(1) rotate(' + rot + 'deg)', opacity: 1, offset: 0.65 },
        { transform: 'translate(' + Math.cos(ang) * dist * 1.1 + 'px,' + (Math.sin(ang) * dist + 50) + 'px) scale(.8) rotate(' + rot * 1.4 + 'deg)', opacity: 0 }
      ], { duration: 1200 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)' });
      an.onfinish = (function (n) { return function () { n.remove(); }; })(d);
    }
  };

  var addItem = P.addItem;
  P.addItem = function (card, size) {
    var before = this.state.socks.length, wasAcc = this.mode === 'accessory';
    addItem.call(this, card, size);
    var after = this.state.socks.length;
    if (wasAcc || after <= before) return;
    var self = this, img = card.querySelector('.gbb-card__img'), idx = after - 1, target;
    if (isMobile()) {
      target = this.miniEl.querySelectorAll('.gbb-dot:not(.gbb-dot--box):not(.gbb-dot--prize)')[idx];
    } else {
      target = this.$$('.gbb__slots .gbb-slot')[idx];
    }
    if (target) target.style.visibility = 'hidden';
    this.flyTo(img, target, function () {
      if (target) target.style.visibility = '';
      if (after === self.socksPerBox) {
        self.confetti(isMobile() ? self.$('.gbb__bar-atc') : self.$('.gbb__slots'));
        self.root.classList.add('gbb--celebrate');
        setTimeout(function () { self.root.classList.remove('gbb--celebrate'); }, 1600);
      }
    });
  };

  var renderSummary = P.renderSummary;
  P.renderSummary = function () {
    renderSummary.call(this);
    var ul = this.$('[data-gbb-slots]'), s = this.state;
    if (!ul) return;
    ul.classList.add('gbb-tray');
    if (s.box && s.box.image) ul.style.setProperty('--gbb-box-img', 'url("' + String(s.box.image).replace(/"/g, '') + '")');
    ul.classList.toggle('is-full', s.socks.length >= this.socksPerBox);
  };

  var openUpsell = P.openUpsell;
  P.openUpsell = function () {
    openUpsell.call(this);
    var m = this.upsell, s = this.state;
    if (!m) return;
    var wrap = m.querySelector('.gbb-msg');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'gbb-msg';
      wrap.innerHTML =
        '<button type="button" class="gbb-msg__toggle" aria-expanded="false">' + txt('msg_label', '✉ Add a gift note') + ' <small>' + txt('msg_hint', '(free · optional)') + '</small><span class="gbb-msg__chev">+</span></button>' +
        '<div class="gbb-msg__body" hidden>' +
          '<textarea class="gbb-msg__input" maxlength="200" rows="2" aria-label="Gift note" placeholder="' + txt('msg_placeholder', 'Happy birthday! Lots of love…') + '"></textarea>' +
          '<div class="gbb-msg__count"><span>0</span>/200</div>' +
        '</div>';
      var foot = m.querySelector('.gbb-up__foot');
      foot.parentNode.insertBefore(wrap, foot);
      var ta0 = wrap.querySelector('textarea'), cnt0 = wrap.querySelector('.gbb-msg__count span');
      var tg = wrap.querySelector('.gbb-msg__toggle'), body = wrap.querySelector('.gbb-msg__body');
      ta0.addEventListener('input', function () { s.message = ta0.value.slice(0, 200); cnt0.textContent = ta0.value.length; });
      tg.addEventListener('click', function () {
        var open = body.hidden;
        body.hidden = !open;
        wrap.classList.toggle('is-open', open);
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) ta0.focus();
      });
      // stickers: tap anywhere on the card to add / remove
      m.addEventListener('click', function (e) {
        if (e.target.closest('.gbb-size, [data-up-close], [data-up-skip], [data-up-go], .gbb-msg')) return;
        var card = e.target.closest('.gbb-up__grid .gbb-card');
        if (!card) return;
        var btn = card.querySelector('.gbb-size:not([disabled])');
        if (btn) btn.click();
      });
    }
    var ta = wrap.querySelector('textarea');
    ta.value = s.message || '';
    wrap.querySelector('.gbb-msg__count span').textContent = ta.value.length;
    var has = !!ta.value;
    wrap.querySelector('.gbb-msg__body').hidden = !has;
    wrap.classList.toggle('is-open', has);
  };

  P.doAddToCart = function () {
    var s = this.state, self = this;
    if (!s.box || s.socks.length < this.socksPerBox) return;
    var btn = this.$('[data-gbb-atc]');
    var label = this.str('add_to_cart');
    btn.disabled = true; btn.textContent = this.str('adding');
    if (this.barAtc) { this.barAtc.disabled = true; this.barAtc.textContent = this.str('adding'); }
    var bundleId = 'GB-' + Date.now().toString(36).toUpperCase();
    var props = { _bundle_id: bundleId, _bundle_box: s.box.title, _bundle_line: s.line || '' };
    var boxProps = { _bundle_id: bundleId, _bundle_box: s.box.title, _bundle_line: s.line || '' };
    var msg = (s.message || '').trim();
    if (msg) boxProps['Gift message'] = msg;
    var items = [{ id: +s.box.variantId, quantity: 1, properties: boxProps }];
    s.socks.forEach(function (it) { items.push({ id: +it.variantId, quantity: 1, properties: props }); });
    (s.extras || []).forEach(function (it) { items.push({ id: +it.variantId, quantity: 1, properties: props }); });
    fetch(this.rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        s.socks = []; s.accessory = null; s.extras = []; s.message = ''; s.box = null;
        btn.textContent = label;
        if (self.barAtc) self.barAtc.textContent = label;
        self.$$('.gbb-box').forEach(function (b) { b.classList.remove('is-selected'); });
        self.root.classList.remove('gbb--summary-open');
        self.goto(1); // hide the sock counter bar so it doesn't sit on top of the cart drawer
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = label;
        if (self.barAtc) self.barAtc.textContent = label;
        self.render();
        self.flash(self.str('error'));
      });
  };

  Array.prototype.forEach.call(document.querySelectorAll('.gbb[data-gbb-ready]'), function (r) { if (r.__gbb) r.__gbb.render(); });
})();

/* ===== v3.3: product card "+" toggle like the collection grid ===== */
(function () {
  function bind(r) {
    var grid = r.querySelector('[data-gbb-grid]');
    if (!grid || grid.__gbbT) return;
    grid.__gbbT = true;
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.gbb-card');
      if (!card) return;
      if (e.target.closest('.gbb-size')) {
        setTimeout(function () {
          card.classList.remove('is-open');
          if (document.activeElement && card.contains(document.activeElement)) document.activeElement.blur();
        }, 60);
        return;
      }
      var onTitle = !!e.target.closest('.gbb-card__title');
      var onMedia = !!e.target.closest('.gbb-card__media');
      if (!onTitle && !(onMedia && window.matchMedia('(hover: none)').matches)) return;
      var open = !card.classList.contains('is-open');
      Array.prototype.forEach.call(grid.querySelectorAll('.gbb-card.is-open'), function (c) { c.classList.remove('is-open'); });
      card.classList.toggle('is-open', open);
    });
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('.gbb[data-gbb-ready]'), bind); }
  all();
  document.addEventListener('shopify:section:load', function () { setTimeout(all, 50); });
})();
/* ===== v3.5: preload the sticker pop-up (HTML + images) so it opens instantly ===== */ (function () { var root = document.querySelector('.gbb[data-gbb-ready]'); var inst = root && root.__gbb; if (!inst) return; var P = Object.getPrototypeOf(inst); if (P.__v35) return; P.__v35 = true; var cache = {}; function accUrl(self) { var tab = self.$('.gbb__tab[data-accessory]'); if (!tab) return null; return self.rootUrl + 'collections/' + tab.dataset.collection + '?section_id=gift-box-grid&filter.v.availability=1'; } P.prefetchExtras = function () { var url = accUrl(this); if (!url || cache[url]) return; cache[url] = fetch(url, { credentials: 'same-origin' }) .then(function (r) { return r.ok ? r.text() : null; }) .then(function (html) { if (!html) return null; var doc = new DOMParser().parseFromString(html, 'text/html'); Array.prototype.forEach.call(doc.querySelectorAll('.gbb-cards .gbb-card__img:not(.gbb-card__img--alt)'), function (i) { var im = new Image(); if (i.getAttribute('sizes')) im.sizes = i.getAttribute('sizes'); if (i.getAttribute('srcset')) im.srcset = i.getAttribute('srcset'); im.src = i.getAttribute('src'); }); return html; }) .catch(function () { delete cache[url]; return null; }); }; var openUpsell = P.openUpsell; P.openUpsell = function () { var url = accUrl(this); if (!this.upsell && url && cache[url]) { var real = window.fetch; window.fetch = function (u, o) { if (String(u) === url) { window.fetch = real; return cache[url].then(function (h) { return h ? new Response(h, { headers: { 'Content-Type': 'text/html' } }) : real(u, o); }); } return real.apply(this, arguments); }; try { return openUpsell.apply(this, arguments); } finally { window.fetch = real; } } return openUpsell.apply(this, arguments); }; function warm() { Array.prototype.forEach.call(document.querySelectorAll('.gbb[data-gbb-ready]'), function (r) { if (r.__gbb) r.__gbb.prefetchExtras(); }); } if (document.readyState === 'complete') setTimeout(warm, 1200); else window.addEventListener('load', function () { setTimeout(warm, 1200); }); })(); /* ===== v3.6: translations ES / FR / DE / IT (English comes from the section settings) ===== */ (function () { var L = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase(); var D = { es: { title: "Crea tu caja de regalo", sub: "Elige una caja, llénala con 3 pares de calcetines y ahorra un 10%.", steps: ["Caja", "Calcetines", "Extra (opcional)"], deal: "Caja + 3 pares = 10% de descuento en los calcetines", box_cta: "Elegir esta caja", search: "Buscar diseño…", your_box: "Tu caja", change: "Cambiar", subtotal: "Subtotal", saving: "Descuento caja", total: "Total", f: { "Colors": "Colores", "Color": "Color", "Size": "Talla" }, t: { add: "Añadir", empty: "Ningún calcetín coincide con estos filtros.", full: "Tu caja está llena. Quita un par para cambiarlo.", missing_one: "Añade 1 par más para conseguir un 10% de descuento", missing_many: "Añade [n] pares más para conseguir un 10% de descuento", ready: "Tu caja está lista – 10% de descuento aplicado en el carrito", switch_line: "No se pueden mezclar calcetines de líneas distintas. ¿Vaciar la caja y cambiar?", adding: "Añadiendo…", add_to_cart: "Añadir caja al carrito", error: "Algo ha ido mal. Inténtalo de nuevo.", in_box: "En tu caja", loading: "Cargando…", upsell_title: "¿La completas con pegatinas?", upsell_sub: "Opcional: añade uno o varios packs de pegatinas a tu caja.", no_thanks: "No, gracias, solo la caja", clear: "Borrar filtros", msg_label: "✉ Añade una nota de regalo", msg_hint: "(gratis · opcional)", msg_placeholder: "¡Feliz cumpleaños! Con mucho cariño…" } }, fr: { title: "Créez votre coffret cadeau", sub: "Choisissez un coffret, ajoutez 3 paires de chaussettes et économisez 10 %.", steps: ["Coffret", "Chaussettes", "Extra (facultatif)"], deal: "Coffret + 3 paires = -10 % sur les chaussettes", box_cta: "Choisir ce coffret", search: "Rechercher un design…", your_box: "Votre coffret", change: "Modifier", subtotal: "Sous-total", saving: "Remise coffret", total: "Total", f: { "Colors": "Couleurs", "Color": "Couleur", "Size": "Taille" }, t: { add: "Ajouter", empty: "Aucune chaussette ne correspond à ces filtres.", full: "Votre coffret est plein. Retirez une paire pour la remplacer.", missing_one: "Ajoutez encore 1 paire pour obtenir -10 %", missing_many: "Ajoutez encore [n] paires pour obtenir -10 %", ready: "Votre coffret est prêt – -10 % appliqué dans le panier", switch_line: "Impossible de mélanger des chaussettes de gammes différentes. Vider le coffret et changer ?", adding: "Ajout…", add_to_cart: "Ajouter le coffret au panier", error: "Une erreur est survenue. Veuillez réessayer.", in_box: "Dans votre coffret", loading: "Chargement…", upsell_title: "On le complète avec des stickers ?", upsell_sub: "Facultatif – ajoutez un ou plusieurs packs de stickers à votre coffret.", no_thanks: "Non merci, juste le coffret", clear: "Effacer les filtres", msg_label: "✉ Ajouter un mot pour le cadeau", msg_hint: "(gratuit · facultatif)", msg_placeholder: "Joyeux anniversaire ! Bisous…" } }, de: { title: "Stell deine Geschenkbox zusammen", sub: "Wähle eine Box, füll sie mit 3 Paar Socken und spare 10 %.", steps: ["Box", "Socken", "Extra (optional)"], deal: "Box + 3 Paar = 10 % Rabatt auf die Socken", box_cta: "Diese Box wählen", search: "Design suchen…", your_box: "Deine Box", change: "Ändern", subtotal: "Zwischensumme", saving: "Box-Rabatt", total: "Gesamt", f: { "Colors": "Farben", "Color": "Farbe", "Size": "Größe" }, t: { add: "Hinzufügen", empty: "Keine Socken passen zu diesen Filtern.", full: "Deine Box ist voll. Entferne ein Paar, um es zu tauschen.", missing_one: "Noch 1 Paar hinzufügen für 10 % Rabatt", missing_many: "Noch [n] Paar hinzufügen für 10 % Rabatt", ready: "Deine Box ist fertig – 10 % Rabatt im Warenkorb", switch_line: "Socken aus verschiedenen Linien können nicht gemischt werden. Box leeren und wechseln?", adding: "Wird hinzugefügt…", add_to_cart: "Box in den Warenkorb", error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.", in_box: "In deiner Box", loading: "Wird geladen…", upsell_title: "Mit Stickern vervollständigen?", upsell_sub: "Optional – füge ein oder mehrere Sticker-Packs zu deiner Box hinzu.", no_thanks: "Nein danke, nur die Box", clear: "Filter löschen", msg_label: "✉ Geschenknachricht hinzufügen", msg_hint: "(kostenlos · optional)", msg_placeholder: "Alles Gute zum Geburtstag! …" } }, it: { title: "Crea la tua scatola regalo", sub: "Scegli una scatola, riempila con 3 paia di calzini e risparmia il 10%.", steps: ["Scatola", "Calzini", "Extra (facoltativo)"], deal: "Scatola + 3 paia = 10% di sconto sui calzini", box_cta: "Scegli questa scatola", search: "Cerca un design…", your_box: "La tua scatola", change: "Cambia", subtotal: "Subtotale", saving: "Sconto scatola", total: "Totale", f: { "Colors": "Colori", "Color": "Colore", "Size": "Taglia" }, t: { add: "Aggiungi", empty: "Nessun calzino corrisponde a questi filtri.", full: "La tua scatola è piena. Rimuovi un paio per sostituirlo.", missing_one: "Aggiungi ancora 1 paio per ottenere il 10% di sconto", missing_many: "Aggiungi ancora [n] paia per ottenere il 10% di sconto", ready: "La tua scatola è pronta – 10% di sconto applicato nel carrello", switch_line: "Non puoi mescolare calzini di linee diverse. Svuotare la scatola e cambiare?", adding: "Aggiunta in corso…", add_to_cart: "Aggiungi la scatola al carrello", error: "Qualcosa è andato storto. Riprova.", in_box: "Nella tua scatola", loading: "Caricamento…", upsell_title: "La completi con degli sticker?", upsell_sub: "Facoltativo – aggiungi uno o più pack di sticker alla tua scatola.", no_thanks: "No grazie, solo la scatola", clear: "Cancella filtri", msg_label: "✉ Aggiungi un biglietto regalo", msg_hint: "(gratis · facoltativo)", msg_placeholder: "Buon compleanno! Un abbraccio…" } } }; var d = D[L]; if (!d) return; function each(sel, fn, r) { Array.prototype.forEach.call((r || document).querySelectorAll(sel), fn); } function apply(root) { var I = root.__gbb; if (!I || root.__i18n) return; root.__i18n = true; Object.keys(d.t).forEach(function (k) { I.t[k] = d.t[k]; }); function q(s) { return root.querySelector(s); } if (q('.gbb__title')) q('.gbb__title').textContent = d.title; if (q('.gbb__sub')) q('.gbb__sub').innerHTML = '<p>' + d.sub + '</p>'; each('.gbb__step', function (b, i) { for (var n = b.firstChild; n; n = n.nextSibling) { if (n.nodeType === 3 && n.nodeValue.trim()) { n.nodeValue = ' ' + d.steps[i] + ' '; break; } } }, root); each('.gbb__deal, .gbb__dealbar-txt b', function (e) { e.textContent = d.deal; }, root); each('.gbb-box__cta', function (e) { e.textContent = d.box_cta; }, root); var s = q('[data-gbb-search]'); if (s) s.placeholder = d.search; if (q('.gbb__summary-title')) q('.gbb__summary-title').textContent = d.your_box; each('.gbb__link[data-goto="1"]', function (e) { e.textContent = d.change; }, root); function dt(sel, t) { var e = q(sel); var x = e && e.parentNode.querySelector('dt'); if (x) x.textContent = t; } dt('[data-gbb-subtotal]', d.subtotal); dt('[data-gbb-save]', d.saving + ' (−' + I.discount + '%)'); dt('[data-gbb-total]', d.total); var acc = q('.gbb__tab[data-accessory]'); if (acc) acc.textContent = d.steps[2]; if (q('[data-gbb-atc]')) q('[data-gbb-atc]').textContent = d.t.add_to_cart; if (I.barAtc) I.barAtc.textContent = d.t.add_to_cart; each('[data-gbb-t]', function (e) { if (d.t[e.dataset.gbbT]) e.textContent = d.t[e.dataset.gbbT]; }, root); I.render(); } var r0 = document.querySelector('.gbb[data-gbb-ready]'); if (r0 && r0.__gbb) { var P = Object.getPrototypeOf(r0.__gbb); if (!P.__i18n && P.buildDropdowns) { P.__i18n = true; var bd = P.buildDropdowns; P.buildDropdowns = function () { var out = bd.apply(this, arguments); each('.gbb-dd summary', function (sm) { var n = sm.firstChild; if (n && n.nodeType === 3) { var k = n.nodeValue.trim(); if (d.f[k]) n.nodeValue = d.f[k] + (/\s$/.test(n.nodeValue) ? ' ' : ''); } }, this.root); return out; }; } } function all() { each('.gbb[data-gbb-ready]', apply); } all(); document.addEventListener('shopify:section:load', function () { setTimeout(all, 50); }); })(); /* ===== v3.7: picker-friendly internal bundle labels ("_Gift box: Heritage A · pair 1/3") ===== */ (function () { var root = document.querySelector('.gbb[data-gbb-ready]'); var inst = root && root.__gbb; if (!inst) return; var P = Object.getPrototypeOf(inst); if (P.__v37) return; P.__v37 = true; var KEY = '_Gift box'; function nextLetter(cart) { var used = {}; ((cart && cart.items) || []).forEach(function (it) { var v = it.properties && it.properties[KEY]; var m = v && /^.* ([A-Z]) · /.exec(v); if (m) used[m[1]] = true; }); for (var i = 0; i < 26; i++) { var l = String.fromCharCode(65 + i); if (!used[l]) return l; } return 'Z'; } P.doAddToCart = function () { var s = this.state, self = this; if (!s.box || s.socks.length < this.socksPerBox) return; var btn = this.$('[data-gbb-atc]'); var label = this.str('add_to_cart'); btn.disabled = true; btn.textContent = this.str('adding'); if (this.barAtc) { this.barAtc.disabled = true; this.barAtc.textContent = this.str('adding'); } var n = s.socks.length, extras = s.extras || []; fetch(this.rootUrl + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }) .then(function (r) { return r.ok ? r.json() : null; }, function () { return null; }) .then(function (cart) { var tag = s.box.title + ' ' + nextLetter(cart); var boxProps = {}; boxProps[KEY] = tag + ' · box (' + n + ' pairs' + (extras.length ? ' + ' + extras.length + ' extra' : '') + ')'; var msg = (s.message || '').trim(); if (msg) boxProps['Gift message'] = msg; var items = [{ id: +s.box.variantId, quantity: 1, properties: boxProps }]; s.socks.forEach(function (it, i) { var p = {}; p[KEY] = tag + ' · pair ' + (i + 1) + '/' + n; items.push({ id: +it.variantId, quantity: 1, properties: p }); }); extras.forEach(function (it) { var p = {}; p[KEY] = tag + ' · extra'; items.push({ id: +it.variantId, quantity: 1, properties: p }); }); return fetch(self.rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); }) .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }) .then(function () { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true })); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); s.socks = []; s.accessory = null; s.extras = []; s.message = ''; s.box = null; btn.textContent = label; if (self.barAtc) self.barAtc.textContent = label; self.$$('.gbb-box').forEach(function (b) { b.classList.remove('is-selected'); }); self.root.classList.remove('gbb--summary-open'); self.goto(1); }) .catch(function () { btn.disabled = false; btn.textContent = label; if (self.barAtc) self.barAtc.textContent = label; self.render(); self.flash(self.str('error')); }); }; })(); /* ===== v3.8: copy the gift message into the order note (prints on the Sendcloud packing slip) ===== */ (function () { var root = document.querySelector('.gbb[data-gbb-ready]'); var inst = root && root.__gbb; if (!inst) return; var P = Object.getPrototypeOf(inst); if (P.__v38) return; P.__v38 = true; var orig = P.doAddToCart; P.doAddToCart = function () { var self = this, msg = (this.state.message || '').trim(); if (msg && this.state.box && this.state.socks.length >= this.socksPerBox) { var done = false; var h = function () { if (done) return; done = true; document.removeEventListener('ajaxProduct:added', h); fetch(self.rootUrl + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }) .then(function (r) { return r.json(); }) .then(function (cart) { var tag = ''; (cart.items || []).forEach(function (it) { var p = it.properties || {}; if (p['Gift message'] === msg && p['_Gift box']) tag = String(p['_Gift box']).split(' · ')[0]; }); var line = 'GIFT MESSAGE' + (tag ? ' (' + tag + ')' : '') + ': ' + msg; var note = cart.note || ''; if (note.indexOf(line) !== -1) return null; return fetch(self.rootUrl + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: note ? note + '\n' + line : line }) }); }) .catch(function () {}); }; document.addEventListener('ajaxProduct:added', h); setTimeout(function () { if (!done) { done = true; document.removeEventListener('ajaxProduct:added', h); } }, 20000); } return orig.apply(this, arguments); }; })();